<template>
    <div>
        <el-dialog
            title="订单详情"
            :visible="msgDialogVisible"
            width="60%"
            top="8vh"
            :close-on-click-modal="false"
            @open="open"
            @close="close"
            center>
            <div class="msg-detail">
                <div class="item">
                   <div class="item-title item-title-border">
                       <div>
                           房屋信息
                       </div>
                   </div>
                    <div class="houseInfo">
                        <div class="houseInfo-img">
                            <img object-fit="contain" :src="orderInfo.houseInfoSon.vCoverPic"/>
                        </div>
                        <div class="content">
                            <div class="houseInfo-title">
                                {{orderInfo.houseInfoMain.vHousTitle}}
                            </div>
                            <div class="houseInfo-service">
                              整套出租  {{orderInfo.houseInfoMain.roomNumber}}室|
                                {{orderInfo.houseInfoMain.hallNumber}}厅|
                                {{orderInfo.houseInfoMain.kitchenNumber}}厨|
                                {{orderInfo.houseInfoMain.bathroomNumber}}卫
                            </div>
                            <div class="houseInfo-location">
                              {{orderInfo.houseInfoMain.address}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="item-title item-title-border">
                        <div>
                            基础信息
                        </div>
                    </div>
                    <div class="baseInfo">
                        <div class="baseInfo-item" v-for="(item,index) in baseInfo" :key="index">
                            <span class="label"> {{item.label+':'}}</span>
                            <span class="value" v-if="item.prop&&item.label!=='手机'"> {{orderInfo.orders[item.prop]}}</span>
                            <span class="value" v-if="!item.prop">{{item.value}}</span>
                            <el-input v-model="orderInfo.orders[item.prop]" clearable maxlength="11" style="height: 30px" v-if="item.label=='手机'"></el-input>
                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="item-title item-title-border">
                        <div>
                            费用信息
                        </div>
                    </div>
                    <div class="baseInfo">
                        <div class="baseInfo-item" v-for="(item,index) in costInfo" :key="index">
                            <span class="label"> {{item.label+':'}}</span>
                            <span class="value"> {{orderInfo.orders[item.prop]}}元</span>

                        </div>
                    </div>
                </div>
                <div class="item">
                    <div class="item-title" style="margin-bottom: 10px">
                        <div>
                            备注
                        </div>
                    </div>
                    <div>
                        <el-input  v-model="orderInfo.cMemo"  clearable type="textarea" maxlength="50"
                                   show-word-limit></el-input>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="close">取 消</el-button>
                <el-button type="primary" @click="submit">确 定</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { getOrdersDetails, updateOrders } from "@/api/index";
import {format} from '@/utils/util'
export default {
    name: "OrderMsgDetail",
    props:{
        msgDialogVisible:{
            type:Boolean,
            default:false
        },
        message:{
            type:Object,
            default:()=>{
                return {
                    id:''
                }
            }
        }
    },
    data(){
        return{
            orderInfo:{
                wxPlaceAnOrder : {
                     describe :   '',
                     totalFee : ''  ,
                     openid :  '' ,
                     originalPrice :  0 ,
                     discount :  0 ,
                     numberOfPeople :  1 ,
                     houseId :  '' ,
                     phone :  '' ,
                     checkInTime :  '' ,
                     leaveTime :   '' ,
                     userId :  '' ,
                     ordersId :  '' ,
                     prepayId :   '' ,
                     deposit :  0 ,
                     days : 1,
                     mCusPlusMoney :  0 ,
                     minValue :  0
                },
                 houseInfoMain : {
                     address :   '' ,
                     iHourseStatus : 0 ,
                     area :  0 ,
                     location :  '' ,
                     longtitude :  '' ,
                     latitude :  '' ,
                     province :  '' ,
                     city :  '' ,
                     district :  '' ,
                     roomNumber :  '' ,
                     hallNumber : '' ,
                     bathroomNumber : '' ,
                     kitchenNumber :  '' ,
                     property :  '' ,
                     vHousTitle :  '' ,
                     cStewardId :   '' ,
                     cHouSteward :   '' ,
                     dOnlineTime :   '' ,
                     cusDefine5 : '' ,
                     del : false,
                     params : {}
                },
                 houseFavour : {
                     mDailyPrice : 0,
                     mWeekEndPrice : 0,
                     mFestivePrice : 0,
                     mDepositMoney : 0,
                     iResidentNum : 0,
                     iCusPlusNum : 0,
                     mCusPlusMoney : 0,
                     iMiniDays : 1,
                     iMaxDays : 0,
                     del : false,
                     params : {}
                },
                 houseInfoSon : {
                     vHourseArea :  0 ,
                     iToiletType : 0,
                     iLiveNum : 0,
                     iSameHourTotal : 0,
                     vHourHighlight : '' ,
                     vSurroundInfo : '' ,
                     vHourloadMess :  '' ,
                     vBedroom : '' ,
                     vCoverPic :   '' ,
                     vSaloonPic : '' ,
                     vToiletPic : '' ,
                     vKitchenPic : '' ,
                     vOtherPic : '' ,
                     iRenderType : '' ,
                     iStayWithLoad :  '' ,
                     del : false,
                     params : {}
                },
                 orders : {
                     id :  '' ,
                     userId :  '' ,
                     houseId :  '' ,
                     wxId :   '' ,
                     userName :   '' ,
                     userPhone :   '' ,
                     type :   '' ,
                     money :  '' ,
                     creationTime :  '' ,
                     dataSources :   '' ,
                     checkInTime :  '' ,
                     leaveTime :  '' ,
                     flag : 1,
                     idCard :   '' ,
                     numberOfPeople : '' ,
                     originalPrice :  '' ,
                     discount : 0,
                     identifier : 1,
                     orderTypes : 1,
                     commission : 0,
                     payReceive : 0,
                     deposit : 0,
                     addMoney : 0,
                     userGroupId :  84 ,
                     days : 1,
                     minValue :  0 ,
                     updateTime : '' ,
                     del : false,
                     params : {}
                }
            },
            baseInfo:[
                {label:'状态',value:''},
                {label:'来源',value:''},
                {label:'订单号',value:'',prop:'id'},
                {label:'下单时间',value:'',prop:'creationTime'},
                {label:'房客',value:'',prop:'userName'},
                {label:'手机',value:'',prop:'phonenumber'},
                {label:'入离时间',value:''}
            ],
            costInfo:[
                {label:'实收房费',value:'100',prop: 'money'},
                {label:'平台佣金',value:'',prop:'deposit'},
                {label:'优惠',value:'',prop:'discount'},
                {label:'加客费',value:'',prop:'addMoney'},

            ]
        }
    },
    mounted() {

    },
    methods:{
        getDataSources(dataSources) {
            let enumStatus = {
                '1': '微信小程序',
                '2': '悠家',
                '3': '美团',
                '4': '途家',
                '5': '小猪',
                '6': '爱彼迎'
            }
            return enumStatus[dataSources];
        },
        open(){
            this.getOrderInfo();
        },
        submit(){
            let from = {
                id:this.orderInfo.orders.id,
                cMemo:this.orderInfo.cMemo,
                phonenumber:this.orderInfo.orders.phonenumber||this.orderInfo.orders.userPhone,
            }
            console.log(from.phonenumber)
            if(from.phonenumber&&from.phonenumber.length<11){
                this.$message.warning('请输入正确的手机号');
                return;
            }

            updateOrders(from).then(res=>{
                if(res.data&&res.data.code==200){
                    this.$message.success('修改成功!');
                    this.$emit("close")
                }
            })
        },
        close(){
            this.$emit("close")
        },
        getStatus(type){
            let enumStatus ={
                '1':'待支付',
                '2':'待确认',
                '3':'待入住',
                '4':'待完成',
                '5':'已完成',
                '6':'未评论',
                '7':'已评论',
                '8':'已取消',
                '9':'超时支付取消',
                '10':'主动拒单取消',
                '11':'超时拒单取消',
                '12':'退款取消',
                '13':'主动取消'
            }
            return enumStatus[type];
        },
        getOrderInfo(){
            // let msgKeys=Object.keys(this.message);
            this.orderInfo=this.message;
            // msgKeys.forEach(item=>{
            //     this.orderInfo=Object.assign(this.orderInfo,this.message[item])
            // })
            // console.log("msgKeys",msgKeys)
            /*this.orderInfo={...this.message.orderList,...this.message.houseFavour,
                ...this.message.houseInfoMain,...this.message.houseInfoSon,...this.message.orders}*/
            console.log('orderInfo',this.orderInfo)

            this.baseInfo[0].value=this.getStatus(this.orderInfo.orders.type)
            this.baseInfo[1].value=this.getDataSources(this.orderInfo.orders.dataSources)
            this.orderInfo.orders.checkInTime=format('{y}-{m}-{d}',new Date(this.orderInfo.orders.checkInTime))
            this.orderInfo.orders.leaveTime=format('{y}-{m}-{d}',new Date(this.orderInfo.orders.leaveTime))
            this.orderInfo.orders.creationTime=format('{y}-{m}-{d}',new Date(this.orderInfo.orders.creationTime))

            this.baseInfo[this.baseInfo.length-1].value=this.orderInfo.orders.checkInTime+'~'+this.orderInfo.orders.leaveTime+`(共${this.orderInfo.orders.days>1?this.orderInfo.orders.days-1:this.orderInfo.orders.days}晚)`
            if(!this.orderInfo.orders.phonenumber){
                this.baseInfo[this.baseInfo.length-2].prop='userPhone'

            }
        }
    }
}
</script>

<style scoped lang="scss">
/deep/ .el-dialog__header{
    text-align: left;
}
/deep/ .msg-detail{
    .item{
        margin-bottom: 20px;
        .item-title div{
            border-left: 5px solid #f6b439;
            height: 30px;
            padding-left: 10px;
            line-height: 30px;
            font-size: 18px;
            font-weight: 400;
        }
        .item-title-border{
            border-bottom: 1px solid #e1e1e1;
            padding-bottom: 10px;
        }
        .houseInfo{
            height: 100px;
            margin-top: 20px;
            display: flex;

            .houseInfo-img{
                width: 20%;
                height: 100%;
                margin-right: 10px;
                img{
                    width: 100%;
                    height: 100%;
                }
            }
            .content{
                font-size: 16px;
                div{
                    margin-bottom: 10px;
                }
                .houseInfo-title{
                    width: 100%;
                    height: 20px;
                    overflow: hidden;
                    white-space: normal;
                    text-align: left;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 1;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    word-break: break-all;
                }
                .houseInfo-service,.houseInfo-location{
                    width: 100%;
                    overflow: hidden;
                    white-space: normal;
                    text-align: left;
                    text-overflow: ellipsis;
                    -webkit-line-clamp: 3;
                    display: -webkit-box;
                    -webkit-box-orient: vertical;
                    word-break: break-all;
                }
            }

        }
        .baseInfo{
            width: 70%;
            display: flex;
            flex-wrap: wrap;
            .baseInfo-item{
                width: 300px;
                height: 30px;
                line-height: 30px;
                margin: 5px;
                display: flex;
                .label{
                    white-space: nowrap;
                    padding-left: 10px;
                }
                .value{
                    padding-left: 10px;
                }
            }
        }
    }
}
/deep/ .el-input__inner{
    height: 30px;
}
</style>
